import React from 'react';

interface PageHeaderProps {
    title: string;
    /** One-line "what this page is for" — mandatory per docs/design/01-independent-gui-base.md app-shell rules. */
    purpose: string;
    actions?: React.ReactNode;
}

/**
 * Shared page header for the redesigned GUI (migration slice 2,
 * docs/design/phase2-refinement.md §5). Pages still on the old GUI keep
 * their own ad hoc header markup — this is only rendered behind useNewGui().
 */
const PageHeader: React.FC<PageHeaderProps> = ({ title, purpose, actions }) => (
    <div className="font-plex flex items-start justify-between gap-4 pb-4 mb-4 border-b border-border-subtle">
        <div>
            <h1 className="text-xl font-semibold text-ink-primary">{title}</h1>
            <p className="text-sm text-ink-secondary mt-0.5">{purpose}</p>
        </div>
        {actions && <div className="flex items-center gap-2 flex-shrink-0">{actions}</div>}
    </div>
);

export default PageHeader;
